import { render } from "./TargetSmall.vue?vue&type=template&id=0508a1f8"
import script from "./TargetSmall.vue?vue&type=script&lang=js"
export * from "./TargetSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__